import { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./FloatingScrollbar.scss";

const FloatingScrollbar = ({ targetRef, extraWidth = 0, fullWidth = false }) => {
  const scrollbarRef = useRef(null);

  const syncScrollbar = useCallback(() => {
    if (targetRef.current && scrollbarRef.current) {
      scrollbarRef.current.scrollLeft = targetRef.current.scrollLeft;
    }
  }, [targetRef]);

  const syncTableScroll = useCallback(() => {
    if (targetRef.current && scrollbarRef.current) {
      targetRef.current.scrollLeft = scrollbarRef.current.scrollLeft;
    }
  }, [targetRef]);

  useEffect(() => {
    const tableRef = targetRef.current;
    if (tableRef) {
      tableRef.addEventListener("scroll", syncScrollbar);
      return () => tableRef.removeEventListener("scroll", syncScrollbar);
    }
  }, [syncScrollbar, targetRef]);

  useEffect(() => {
    const scrollbar = scrollbarRef.current;
    if (scrollbar) {
      scrollbar.addEventListener("scroll", syncTableScroll);
      return () => scrollbar.removeEventListener("scroll", syncTableScroll);
    }
  }, [syncTableScroll]);

  useEffect(() => {
    if (targetRef.current && scrollbarRef.current) {
      const scrollWidth = targetRef.current.scrollWidth;
      const scrollbarContent = scrollbarRef.current.firstChild;
      if (scrollbarContent) {
        scrollbarContent.style.width = `${scrollWidth + extraWidth}px`;
      }
    }
  });

  return (
    <div
      className={`floating-scrollbar${fullWidth ? " floating-scrollbar--full-width" : ""}`}
      ref={scrollbarRef}
    >
      <div className="scrollbar-content" />
    </div>
  );
};

export default FloatingScrollbar;

FloatingScrollbar.propTypes = {
  targetRef: PropTypes.object.isRequired,
  extraWidth: PropTypes.number,
  fullWidth: PropTypes.bool,
};
